import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from '../../utils/API/requestMiddleware';


const imageRequestAPI = createApi({
    baseQuery: defautBaseQuery, // Replace with your API endpoint
    reducerPath: 'imageRequestAPI',
    endpoints: (builder) => ({
        addImageRequest: builder.mutation({
            query: (details) => ({
                url: '/ImageGeneration/AddImageGenerationRequest',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getImageRequestById: builder.query({
            query: (id) => ({
                url: (`/ImageGeneration/GetImageGenerationDetailByID?ImageGenerationRequestID=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getProductAndImageCounts: builder.query({
            query: () => ({
                url: '/ImageGeneration/GetProductAndImageCounts',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getGridData: builder.query({
            query: function (params) {
                const { url } = params;
          
                let { first, rows, sortField, sortOrder,search, ...retVal } = params.params;

                retVal.Pagination = {
                    PageNumber: (first / rows) + 1,
                    PageSize: rows
                };
                retVal.filters= { searchText:search || ""};
                retVal.sortString='';
                //retVal.pageIndex = (first / rows);
                //retVal.pageSize = rows;

                if (sortField) {
                    retVal.sortField = sortField;
                    retVal.sortDesc = sortOrder < 0;
                }

                return {
                    url: params.url,
                    params: { requestData: JSON.stringify(retVal) }
                };
            },
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
    useAddImageRequestMutation,
    useLazyGetImageRequestByIdQuery,
    useLazyGetGridDataQuery,
    useLazyGetProductAndImageCountsQuery

} = imageRequestAPI;

export default imageRequestAPI;